module.exports = __webpack_public_path__ + "img/success.8b55eee4.png";